
import templateUrl from './employee-work-order-product-order-list.component.html'
export const EmployeeWorkOrderProductOrderListComponent = {
    controller: EmployeeWorkOrderProductOrderListController,
    controllerAs: "vm",
    bindings: {
        workOrder: "<"
    },
    templateUrl
};

function EmployeeWorkOrderProductOrderListController() {
    'ngInject';

    const vm = this;
    vm.$onInit = onInit;
    vm.getProductCommissionTotal = getProductCommissionTotal;
    vm.getMultiPlayCommissionTotal = getMultiPlayCommissionTotal;

    function onInit() {

    }
    function getProductCommissionTotal() {
        return vm.workOrder.WorkOrder.ProductOrders.reduce(function (s, a) {
            return s + a.PayoutAmount;
        }, 0);
    }
    function getMultiPlayCommissionTotal() {
        return vm.workOrder.PayoutTotals.MultiPlayPayouts.reduce(function (s, a) {
            return s + a.PayoutAmount;
        }, 0);
    }
}
